package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.fa.FaGoogle
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.core.Logger
import info.rezident.app.data.auth.AuthRepository
import info.rezident.app.ui.theme.AppTheme
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px

/**
 * Google Sign-In button using Firebase Auth redirect flow.
 *
 * Redirects to Google auth page, processes result automatically on return.
 * Uses existing AuthRepository.signInWithGoogle method with idToken extracted from redirect result.
 *
 * @param modifier Additional modifiers for button styling
 * @param isLoading Whether the button should show loading state
 * @param enabled Whether the button is enabled
 */
@Composable
fun GoogleSignInButton(
    modifier: Modifier = Modifier,
    isLoading: Boolean = false,
    enabled: Boolean = true,
) {
    val scope = rememberCoroutineScope()
    var isRedirecting by remember { mutableStateOf(false) }

    Button(
        onClick = {
            if (!isRedirecting) {
                isRedirecting = true
                scope.launch {
                    val result = AuthRepository.initiateGoogleSignInRedirect()
                    if (result.isFailure) {
                        isRedirecting = false
                        Logger.error("Failed to start Google redirect: ${result.exceptionOrNull()}")
                    }
                    // If successful, page will redirect so we don't reset isRedirecting
                }
            }
        },
        modifier = modifier
            .backgroundColor(AppTheme.colors.accent)
            .borderRadius(AppTheme.shapes.mediumRound),
        enabled = enabled && !isLoading && !isRedirecting
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.gap(8.px)
        ) {
            FaGoogle(
                modifier = Modifier.color(AppTheme.colors.onAccent)
            )
            SpanText(
                text = when {
                    isLoading -> "Se procesează..."
                    isRedirecting -> "Redirecționare..."
                    else -> "Continuă cu Google"
                },
                modifier = AppTheme.typography.body1Medium.toModifier()
                    .color(AppTheme.colors.onAccent)
            )
        }
    }
}